import { Text } from '@wartek-id/text'

import type { FC } from 'react'

interface DataInfoProps {
  name?: string
}

const DataInfo: FC<DataInfoProps> = ({ name = 'operator dinas' }) => {
  return (
    <div className="bg-surface-subdued px-4 py-3 rounded">
      <Text variant="helper" color="subdued">
        Jika ada data yang salah, hubungi{' '}
        <span className="font-bold">{name}</span> untuk memperbarui data.
      </Text>
    </div>
  )
}
export default DataInfo
